/**
 * /devhub/self-update — Phase 9 SelfUpdateActor surface.
 * REQ-001.91 DevHub UI rebuild · Phase 9 (self-update / self-fix).
 *
 * Operator-only (routePolicy plane guard + DevHubPanelPage self-guard).
 */

import { createFileRoute } from '@tanstack/react-router';
import { DevHubSelfUpdatePanel } from '../features/control-plane/DevHubSelfUpdatePanel';
import { DevHubPanelPage } from '../components/devhub/DevHubPanelPage';

export const Route = createFileRoute('/devhub/self-update')({
  component: SelfUpdatePage,
});

function SelfUpdatePage() {
  return (
    <DevHubPanelPage
      title="Self-Update"
      subtitle="Phase 9 — self-update / self-fix subsystem (the immune system). 5 default watchers detect drift in version registries, parameter schemas, eval results, contract shapes, and upstream Apple package updates. Auto-fix is gated to the version_drift watcher (low-risk version_bump ActionFrame); the rest notify the operator. All arming requires the operator role + the self_update.master_switch_armed parameter."
      status={{ state: 'polling', label: 'opt-in', detail: 'Phase 9' }}
    >
      <DevHubSelfUpdatePanel />
    </DevHubPanelPage>
  );
}
